import { render, staticRenderFns } from "./vendorStatement.vue?vue&type=template&id=1553b3c2"
import script from "./vendorStatement.vue?vue&type=script&lang=js"
export * from "./vendorStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports